import React, {useEffect, useRef} from 'react';

const ProvenProcessStepImage = (props: { currentStep: number, stepCallback: Function }) => {
        const ref = useRef(null);

        useEffect(() => {
            const svgElement = ref.current;
            if (svgElement) {
                // @ts-ignore
                const stepElements = svgElement?.querySelectorAll('[data-step]');
                stepElements.forEach((el: any) => {
                    el.addEventListener('mouseover', () => {
                        const step = parseInt(el.getAttribute('data-step') as string);
                        props.stepCallback(step);
                    });
                });
            }

            return () => {
                // @ts-ignore
                const stepElements = svgElement?.querySelectorAll('[data-step]');
                stepElements.forEach((el: any) => {
                    el.removeEventListener('mouseover', null);
                });
            }
        }, [props.currentStep]);

        return <div
            ref={ref}
            dangerouslySetInnerHTML={{
                __html: `
        <?xml version="1.0" encoding="UTF-8"?>
<svg id="stepimage" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480.01 124.66">
  <defs>
    <style>
      .cls-1 {
        fill: #eaeaea;
      }
      
      text {
      pointer-events: none;
      }

      .cls-1, .cls-2, .cls-3 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: #ddd;
      }

      .cls-4 {
        letter-spacing: 0em;
      }

      .cls-5 {
        letter-spacing: 0em;
      }

      .cls-6 {
        letter-spacing: -.01em;
      }

      .cls-3 {
        fill: #343747;
      }

      .cls-7 {
        letter-spacing: 0em;
      }

      .cls-8 {
        fill: #fff;
        font-family: Inter, "Open Sans", sans-serif;
        font-size: 22.82px;
      }
    </style>
  </defs>
  <g id="Layer_1-2" data-name="Layer 1">
    <path class="cls-1" d="M419.88.04c-15.2-.52-29.23,4.4-40.3,12.97-12.33,9.54-29.64,9.89-41.9.27-10.59-8.31-23.93-13.27-38.44-13.27s-27.85,4.96-38.44,13.27c-12.14,9.53-29.43,9.53-41.57,0-10.59-8.31-23.93-13.27-38.44-13.27s-27.85,4.96-38.44,13.27c-12.26,9.63-29.58,9.28-41.9-.27C89.36,4.44,75.33-.49,60.13.04,27.15,1.17.51,28.37,0,61.37c-.53,34.87,27.58,63.3,62.33,63.3,14.51,0,27.85-4.96,38.44-13.27,12.14-9.53,29.43-9.53,41.57,0,10.59,8.31,23.93,13.27,38.44,13.27s27.85-4.96,38.44-13.27c12.14-9.53,29.43-9.53,41.57,0,10.59,8.31,23.93,13.27,38.44,13.27s27.85-4.96,38.44-13.27c12.14-9.53,29.43-9.53,41.57,0,10.59,8.31,23.93,13.27,38.44,13.27,34.75,0,62.85-28.43,62.33-63.3-.5-33-27.14-60.19-60.12-61.33ZM419.13,98.66c-8.28,0-15.91-2.56-22.02-7.24-10.79-8.26-23.86-12.75-37.44-12.75h0c-13.59,0-26.66,4.5-37.46,12.76-6.11,4.67-13.73,7.36-22.01,7.36s-15.98-2.87-22.09-7.54c-10.8-8.26-23.53-13.03-37.53-13.03v-.02c-13,0-26.58,4.74-37.38,13-6.11,4.67-13.7,7.48-21.97,7.48s-15.88-2.57-21.99-7.24c-10.8-8.26-23.85-12.76-37.44-12.76h0c-13.59,0-26.65,4.49-37.44,12.75-6.11,4.67-13.74,7.36-22.02,7.36-20.93,0-37.73-17.78-36.22-39.03,1.26-17.82,15.65-32.28,33.46-33.59,9.51-.7,18.32,2.49,25.15,7.86,10.44,8.2,23.44,12.66,36.71,12.66h.71c13.46,0,26.44-4.85,37.14-13,6.1-4.64,13.71-7.53,21.97-7.53s15.87,2.94,21.97,7.59c10.71,8.15,23.69,12.94,37.14,12.94h.71c13.46,0,26.44-4.85,37.14-13,6.1-4.64,13.71-7.53,21.97-7.53s15.87,2.94,21.97,7.59c10.71,8.15,23.69,12.94,37.14,12.94h.71c13.27,0,26.28-4.48,36.71-12.67,6.83-5.37,15.64-8.45,25.15-7.75,17.82,1.31,32.2,15.68,33.46,33.5,1.51,21.26-15.29,38.91-36.22,38.91Z"/>
    <g>
      <rect class="cls-3" x="124.58" y="61.67" width="20" height="2"/>
      <polygon class="cls-3" points="137.8 71.34 136.39 69.92 143.64 62.67 136.39 55.42 137.8 54 146.47 62.67 137.8 71.34"/>
      <g>
        <rect class="cls-3" x="93.58" y="61.67" width="4" height="2"/>
        <path class="cls-3" d="M119.58,63.67h-3v-2h3v2ZM115.58,63.67h-5v-2h5v2ZM109.58,63.67h-5v-2h5v2ZM103.58,63.67h-5v-2h5v2Z"/>
        <rect class="cls-3" x="119.58" y="61.67" width="4" height="2"/>
      </g>
    </g>
    <g>
      <rect class="cls-3" x="244.58" y="61.67" width="20" height="2"/>
      <polygon class="cls-3" points="257.8 71.34 256.39 69.92 263.64 62.67 256.39 55.42 257.8 54 266.47 62.67 257.8 71.34"/>
      <g>
        <rect class="cls-3" x="213.58" y="61.67" width="4" height="2"/>
        <path class="cls-3" d="M239.58,63.67h-3v-2h3v2ZM235.58,63.67h-5v-2h5v2ZM229.58,63.67h-5v-2h5v2ZM223.58,63.67h-5v-2h5v2Z"/>
        <rect class="cls-3" x="239.58" y="61.67" width="4" height="2"/>
      </g>
    </g>
    <g>
      <rect class="cls-3" x="366.58" y="61.67" width="20" height="2"/>
      <polygon class="cls-3" points="379.8 71.34 378.39 69.92 385.64 62.67 378.39 55.42 379.8 54 388.47 62.67 379.8 71.34"/>
      <g>
        <rect class="cls-3" x="335.58" y="61.67" width="4" height="2"/>
        <path class="cls-3" d="M361.58,63.67h-3v-2h3v2ZM357.58,63.67h-5v-2h5v2ZM351.58,63.67h-5v-2h5v2ZM345.58,63.67h-5v-2h5v2Z"/>
        <rect class="cls-3" x="361.58" y="61.67" width="4" height="2"/>
      </g>
    </g>
    <g>
      <circle data-step="1" class="cls-2 cursor-pointer z-10 ${props.currentStep === 1 ? 'active' : ''}" cx="62.34" cy="62.34" r="26.46"/>
      <text class="cls-8" transform="translate(45.66 70.1)"><tspan class="cls-6" x="0" y="0">.</tspan><tspan class="cls-5" x="4.59" y="0">0</tspan><tspan x="19.65" y="0">1</tspan></text>
    </g>
    <circle data-step="2" class="cls-2 cursor-pointer z-10 ${props.currentStep === 2 ? 'active' : ''}" cx="181.91" cy="62.34" r="26.46"/>
    <text class="cls-8" transform="translate(162.86 70.1)"><tspan class="cls-6" x="0" y="0">.</tspan><tspan class="cls-5" x="4.59" y="0">0</tspan><tspan x="19.65" y="0">2</tspan></text>
    <circle data-step="3" class="cls-2 cursor-pointer ${props.currentStep === 3 ? 'active' : ''}" cx="300.27" cy="62.34" r="26.46"/>
    <text class="cls-8" transform="translate(281.37 70.1)"><tspan class="cls-6" x="0" y="0">.</tspan><tspan class="cls-7" x="4.59" y="0">0</tspan><tspan class="cls-4" x="19.47" y="0">3</tspan></text>
    <circle data-step="4" class="cls-2 cursor-pointer ${props.currentStep === 4 ? 'active' : ''}" cx="420.58" cy="62.34" r="26.46"/>
    <text class="cls-8" transform="translate(400.45 70.1)"><tspan class="cls-6" x="0" y="0">.</tspan><tspan x="4.59" y="0">04</tspan></text>
  </g>
</svg>
      `,
            }}
        />
    }
;

export default ProvenProcessStepImage;